<template>
  <div class="openstreetmap">
    <l-map
      :zoom="zoom"
      :maxBounds="maxBounds"
      :minZoom="minZoom"
      :center="center"
      id="map"
      ref="map"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-marker
        v-for="(location, index) in centersData"
        :lat-lng="location.position"
        v-bind:key="index"
      >
        <l-popup>
          <div class="custom-popup-content">
            <h3 class="mb-2">{{ location.nama_rs }}</h3>
            <div><strong>Kepemilikan: </strong>{{ location.kepemilikan }}</div>
            <div>
              <strong>Radiasi Eksterna: </strong
              >{{ location.radiasi_eksterna ? "🟢" : "🔴" }}
            </div>
            <div>
              <strong>Brakhiterapi: </strong
              >{{ location.brakhiterapi ? "🟢" : "🔴" }}
            </div>
            <div>
              <strong>Praktek BPJS: </strong
              >{{ location.bpjs ? "🟢" : "🔴" }}
            </div>
            <div>
              <strong>Praktek Swasta: </strong
              >{{ location.swasta ? "🟢" : "🔴" }}
            </div>
            <div>
              <strong>Lokasi: </strong>
              <a :href="location.link" target="_blank"> Lokasi </a>
            </div>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<style type="text/css">
.leaflet-popup-close-button {
  display: none;
}
</style>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue3-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
L.Icon.Default.imagePath = "images/";

export default {
  name: "HospitalMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data: () => ({
    zoom: 5.2,
    minZoom: 5,
    maxBounds: [
      [-11.0, 95.0],
      [6.0, 141.0],
    ],
    center: L.latLng(-1.797068, 111.370529),
    url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
    attribution:
      'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
      '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
      'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    id: "mapbox/streets-v11",
  }),
  computed: {
    centersData() {
      return this.$store.state.centersData;
    },
  },
};
</script>

<style>
#map {
  height: 60vh !important;
}
.leaflet-container {
  background: #cce8ff;
  outline: 0;
}
.custom-popup-content {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.6;
  min-width: 200px;
}
.custom-popup-content h3 {
  font-weight: 700;
  color: #0d47a1;
  font-size: 15px;
}
</style>
